import { createSelector } from '@reduxjs/toolkit';
import { PreventPreemptionsListState } from 'ducks/prevent-preemptions-list/slices';
import { RootState } from 'store';

const preventPreemptionsListSlice = (state: RootState) => state.prevent_preemptions_list;

export const selectPreventPreemptionsList = createSelector(
  [preventPreemptionsListSlice],
  (state): PreventPreemptionsListState[] => state,
);
